exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page-header_header {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\n}\n.page-header_header .header-link-button {\r\n  font-weight: 700;\r\n  text-transform: initial;\r\n  color: rgba(44, 97, 213, 1);\r\n  font-size: 16px;\n}\n.page-header_header + .page_title{\r\n  font-size: 22px;\r\n  font-weight: 200;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-da676054","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/page-header.vue
// module id = 651
// module chunks = 0